import React, { useEffect, useState } from 'react'
import axios from 'axios'

import CustomRadioBoxes from './Checkbox/CustomRadioBoxes'

const options = [{
  value: 'opt_in',
  label: 'Subscribe',
}, {
  value: 'opt_out',
  label: 'Unsubscribe',
}]

function GdprConsentSelection() {
  const [gdprConsent, setGdprConsent] = useState('')

  useEffect(() => {
    axios.get('/api/internal/users/me')
      .then((response) => {
        setGdprConsent(response.data.data.attributes.gdprConsent)
      })
  }, [])

  function onSelectionClick(value) {
    axios.put('/api/internal/users/update-gdpr-answer', { answer: value })
  }

  if (gdprConsent !== 'undecided') {
    return null
  }

  return (
    <div className="gdpr-section-wrapper">
      <hr />

      <div className="cgt-legacy-heading-h6 cgt-mb-20">
        Subscribe to our newsletters with updates on CGTrader features, community news and special offers.
      </div>

      <CustomRadioBoxes
        options={options}
        onChange={onSelectionClick}
      />

      <hr />
    </div>
  )
}

export default GdprConsentSelection
